import ICON__upload_solid from '@/assets/icons/font_awesome/upload-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph } from '@/utils/_methods/FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph';
import { upload_image_single } from '@/utils/utils_upload';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { useTranslation } from 'react-i18next';

interface PROPS {
  field: FIELD__image_asset;
}

export function G_GRAPH__BUTTON__image_upload({ field }: PROPS) {
  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  /*
   * STORE
   */
  const { generation_current } = use_slice_generation(['generation_current']);
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const { toast } = useToast();

  /*
   * STATE
   */

  /*
   * EVENTS
   */
  function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    upload_image_single(toast, file_data => FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph(file_data, field), t_base_ui);
  }

  /*
   * METHODS
   */
  function is_disabled(): boolean {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (!field.is_ready_for_manual_edit()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE))
    return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (!field.is_category_image) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;

  return (
    <UI_PRIMITIVE__button disabled={is_disabled()} size={'square-6'} variant={'no-border-on-bar'} {...{ onClick }}>
      <ICON__upload_solid className="!size-3" />
    </UI_PRIMITIVE__button>
  );
}
